// extracted by mini-css-extract-plugin
export default {"button":"AJOCXhrHJJV__jEssk3t","devices":"mQ7cQxaaNd3ZXLHQG2Pr","title":"vEbrkzOyVCS22Liab3Tq"};